import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    checkbox1,
    organizationName,
    address,
    district,
    province,
    taxAgencyId,
    taxAgencyName,
    taxId2,
    certificate,
    signer,
    fullName,
    timeSign,
    email,
    fax,
    phone,
  },
} = checkout;

const validation = Yup.object().shape({
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [organizationName.name]: Yup.string().required(organizationName.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [taxAgencyId.name]: Yup.string().required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().required(taxAgencyName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
});

export default validation;
